<template>
  <tv-page title="模板" :class="_.page">
    <template v-if="!loading">
      <div :class="_.explain">
        <p :class="_.title">退款说明</p>
        <ul>
          <li v-if="rule.unusedRate === 100">未使用时可随时申请退款</li>
          <li v-else>未使用时退款将扣除{{ 100 - rule.unusedRate }}%的手续费</li>
          <li v-if="rule.expireRate === 100">
            过期时会自动发起退款，1-7个工作日退款金额根据支付方式原路返回
          </li>
          <li v-else>
            过期会自动发起退款，将扣除{{
              100 - rule.expireRate
            }}%的手续费，1-7个工作日退款金额根据支付方式原路返回
          </li>
        </ul>
      </div>
    </template>
  </tv-page>
</template>

<script>
  import Vue from 'vue'
  import { Track } from '@/utils'

  export default Vue.extend({
    mixins: [
      Track.provideMark(() => ({
        // 埋点页面名称
        name: 'TV标销-退款说明',
      })),
    ],

    data: () => ({
      // 页面加载状态
      loading: true,
      rule: '',
    }),

    mounted() {
      this.rule = JSON.parse(this.$route.query.rule)
      this.loading = false
    },
  })
</script>

<style lang="scss" module>
  .page {
    background-color: #1f2733;
  }

  .explain {
    padding: 120px 260px;

    .title {
      font-size: 48px;
      font-weight: bold;
      color: #d2d3d6;
      line-height: 70px;
      text-align: center;
      margin-bottom: 80px;
    }

    ul {
      li {
        font-size: 32px;
        color: #d2d3d6;
        line-height: 46px;
        position: relative;
        padding-left: 20px;
        margin-bottom: 5px;
      }

      li::after {
        content: '';
        width: 5px;
        height: 5px;
        background: #d2d3d6;
        border-radius: 5px;
        position: absolute;
        left: 0;
        top: 20px;
      }
    }
  }
</style>
